<template>
  <p
    v-if="!inline"
    :class="[
      propClasses,
      {
        'underline-text': underline,
        'uppercase': uppercase,
        'lowercase': lowercase,
        'weight-500': bold,
        italic: italic
      }
    ]"
  >
    <slot />
  </p>
  <span
    v-else
    :class="[
      propClasses,
      {
        'underline-text': underline,
        'uppercase': uppercase,
        'lowercase': lowercase,
        'weight-500': bold,
        italic: italic
      }
    ]"
  >
    <slot />
  </span>
</template>
<script setup>
import { computed } from "vue"
const props = defineProps({
  inline: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: "md"
  },
  align: {
    type: String,
    default: "left"
  },
  bold: {
    type: Boolean,
    default: false
  },
  underline: {
    type: Boolean,
    default: false
  },
  italic: {
    type: Boolean,
    default: false
  },
  uppercase: {
    type: Boolean,
    default: false
  },
  lowercase: {
    type: Boolean,
    default: false
  }
})

const propClasses = computed(() => {
  return `text-${props.size} text-${props.align}`
})
</script>
<style scoped>
p {
  margin: 0;
}
.underline-text {
  text-decoration: underline;
}
</style>
